<template>
    <div>

        <!-- page header -->
        <page-heading :show="true" pageTitle="COMPLAT-COOPERATE-TITLE"></page-heading>

    	<!-- show loading indicator -->
    	<loading-indicator :loading="isInitialLoading"></loading-indicator>

    	<template v-if="!isInitialLoading">

            <v-client-table ref="tblHiPrint" name="tblHiPrint" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tblHiPrint noFirstColumn">

                <!-- before table: FILTER OPTIONS -->
                <template slot="beforeTable">

                    <!-- SEARCH -->
                    <!--
                    <form class="control has-addons is-pulled-left" @submit.prevent="search()">
                        <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
                        <span class="button is-info" @click="search()">
                            <span class="icon is-small"><i class="fa fa-search"></i></span>
                        </span>
                    </form>
                    -->

                    <div class="is-pulled-right">
                        <div class="columns is-marginless filters">

                            <!-- ASSIGNEE -->
                            <!--
                            <div class="column">
                                <form-input label="COMPLAT-DASHBOARD-FILTER-USER" minWidth="200px" maxWidth="300px" inputType="select" :selectAllowEmpty="false" :selectIsDisabled="isDisabled" :selectIsSearchable="true" :selectOptions="users" selectCustomLabel="person.fullName" selectFieldName="username" :showLabel="false" :showLabelInOptions="false" v-model="filteredUser" :is-horizontal="false"></form-input>
                            </div>
                            -->

                            <!-- CHANNELS -->
                            <div class="column">
                                <!-- <form-input label="COMPLAT-DASHBOARD-FILTER-CHANNEL" minWidth="250px" maxWidth="300px" inputType="select" :selectIsSearchable="true" :selectOptions="channels" :showLabelInOptions="false" v-model="filteredChannel" :showLabel="false" :is-horizontal="false"></form-input> -->
                                <form-input label="COMPLAT-HIPRINT-FILTER-CHANNEL" minWidth="250px" maxWidth="300px" inputType="select" :selectIsSearchable="false" :selectOptions="channelOptions" :selectAllowEmpty="false" :showLabelInOptions="false" v-model="filteredChannel" :showLabel="false" :is-horizontal="false"></form-input>
                            </div>

                        </div>
                    </div>

                </template>

                <!-- picture -->
                <template slot="teaserImage" slot-scope="props">
                    <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImage(props.row.asset)" :key="props.row.id"></div>
                </template>

                <!-- status -->
                <template slot="status" slot-scope="props">
                    <lang :labelKey="'COMPLAT-HIPRINT-STATUS-'+props.row.status"></lang>
                </template>

                <!-- deadline -->
                <template slot="deadline" slot-scope="props">
                    <template v-if="props.row.deadline != null">
                        <!-- {{ formatDate2(new Date(props.row.deadline), false) }} -->
                        {{ props.row.deadline.substr(0, 10) }}
                    </template>
                </template>

                <!-- updated -->
                <template slot="updated" slot-scope="props">

                    <template v-if="props.row.updated != null">
                        <!-- {{ formatDate2(new Date(props.row.updated)) }} -->
                        {{ props.row.updated.substr(0, 16) }}
                    </template>
                    <template v-else>
                        --
                    </template>
                </template>

                <!-- download -->
                <template slot="download" slot-scope="props">
                    <span class="icon is-small" @click.prevent.stop="downloadPackage(props)" title="download als ZIP Package"><i class="icon-ak-download"></i></span>
                </template>

            </v-client-table>

            <template v-if="showDownload">
                <download :api="downloadAPI" title="Material Download" :show="showDownload" @close="showDownload=false"></download>
            </template>

        </template>

    </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import download from '../../utils/incl-download'

export default {

	name: 'COMPLAT-DASHBOARD',

    components: {
        download
    },

    data() {

        return {

            showDownload: false,
            downloadAPI: null,

            isInitialLoading: false,
            isLoading: false,
            channels: [],

            filteredUser: null,
            filteredChannel: null,

            options: [],
            table: {

                tblColumns: ['teaserImage', 'title', 'status', 'deadline', 'updated', 'download'],

                tblData: [],

                tblOptions: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        ascending: false,
                        column: 'updated'
                    },

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        teaserImage: function(h) {
                            return <lang labelKey="COMPLAT-HIPRINT-TBL_HEADER-KEY_VISUAL"></lang>
                        },
                        title: function(h) {
                            return <lang labelKey="COMPLAT-HIPRINT-TBL_HEADER-TITLE"></lang>
                        },
                        status: function(h) {
                            return <lang labelKey="COMPLAT-HIPRINT-TBL_HEADER-STATUS"></lang>
                        },
                        deadline: function(h) {
                            return <lang labelKey="COMPLAT-HIPRINT-TBL_HEADER-DEADLINE"></lang>
                        },
                        updated: function(h) {
                            return <lang labelKey="COMPLAT-HIPRINT-TBL_HEADER-LAST_UPDATE"></lang>
                        },
                        download: function(h) {
                            return <lang labelKey="COMPLAT-HIPRINT-TBL_HEADER-DOWNLOAD"></lang>
                        }
                    },

                    sortable: ['title', 'status', 'deadline', 'updated'],

                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'Aktuell sind keine zugewiesenen Beiträge für Sie vorhanden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    templates: {

                    },

                    // custom filter functions
                    customFilters: [
                        {
							name: 'filter',
							callback: function(row, filter) {

								// reset filter
								if(filter == null) {
									return true;
								}
                                return row.type.toLowerCase() == filter;
                            }
                        }
                    ],

                }
            }


        }
    },

    created() {

        this.fetchInitialData();

    },

    mounted() {

        Event.$on('vue-tables.tblHiPrint.row-click', function(data) {
            this.$router.push({ name: 'complatContentPoolContent', params: { 'contentID': data.row.articleId, 'tab': 'COOPERATE' }});
        }.bind(this));

    },

    computed: {

        channelOptions() {
            return this.channels;
        },

    },

    watch: {

        filteredChannel(channel) {
            if(typeof channel != 'undefined') {
                this.fetchData(channel.id);
            }
        },


    },


    methods: {

        downloadPackage(prop) {

            this.downloadAPI = 'articleVariant/'+prop.row.id+'/zip';
            this.showDownload = true;

        },

        getImage(asset) {

			if(asset == null) {
				return '';
			}

            return this.$config.assets + asset;

		},

        fetchInitialData() {

            this.isInitialLoading = true;
            var self = this;

            function getChannels() {
                return self.axios.get(self.$config.api + 'cooperateMagazine');
            }
            function getArticles() {
                return self.axios.get(self.$config.api + 'articleVariant/cooperateMagazineList?cooperateMagazine=1');
            }

            this.axios.all([getChannels(), getArticles()])
                .then(self.axios.spread(function (resChannels, resArticles) {

                    self.table.tblData = resArticles.data;
                    self.channels = resChannels.data.cooperateMagazine;


                    // find the closest channel option date to now
                    // this should be initially selected
                    var now = new Date();
                    var closest = Infinity;

                    self.channels.forEach(ch => {
                       var date = new Date(ch.publishDate);
                       if (date >= now && date < closest) {
                          closest = ch;
                       }
                    });

                    self.filteredChannel = closest;

                    self.isInitialLoading = false;

                })).catch(function(error) {
                    console.log("ERROR: ", error);
                });


        },


        fetchData(catalogId) {

			this.isLoading = true;
			var self = this;

            this.axios.get(this.$config.api + 'articleVariant/cooperateMagazineList?cooperateMagazine='+catalogId)
                .then(response => {
                    self.table.tblData = response.data;
                    self.isLoading = false;
                })

        },

    }

}

</script>


<style scoped>

    .tblHiPrint >>> th:first-child {
        width: 120px;
        max-width: 120px;
    }
    .tblHiPrint >>> th:last-child {
        width: 140px;
        max-width: 140px;
    }

    .imgWrapper {
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
        width: 80px;
        height: 60px;
        margin: 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }
    .imgWrapper[lazy=loading]  {
        background-size: 30% !important;
    }
    .imgWrapper[lazy=error]  {
        background-image: none !important;
    }

</style>
